import { combineReducers } from "redux";

import { BOOKINGS_VIEWS, BOOKINGS_TABS } from "../Bookings";
import { FiltersReducer, initialState as filtersInitialState } from "./FiltersReducer"
import { BookingFormReducer, initialState as bookingFormInitialState } from "./BookingFormSlice";
import { commonReducerFor, initialState as commonInitialState } from "../../../Redux/CommonReducer";
import { bookingListReducerFor, initialState as bookingListInitialState } from "./BookingListSlice";
import { LocalReducer, initialState as localInitialState } from "./LocalReducer";

export const bookingsModuleSliceReducer = combineReducers({
    common: commonReducerFor('BOOKINGS'),
    local: LocalReducer,
    bookingForm: BookingFormReducer,
    bookingList: combineReducers({
        [BOOKINGS_VIEWS.MY_BOOKINGS]: combineReducers({
            [BOOKINGS_TABS.UPCOMING]: bookingListReducerFor(BOOKINGS_VIEWS.MY_BOOKINGS, BOOKINGS_TABS.UPCOMING),
            [BOOKINGS_TABS.PAST]: bookingListReducerFor(BOOKINGS_VIEWS.MY_BOOKINGS, BOOKINGS_TABS.PAST),
        }),
        [BOOKINGS_VIEWS.ALL_BOOKINGS]: combineReducers({
            [BOOKINGS_TABS.UPCOMING]: bookingListReducerFor(BOOKINGS_VIEWS.ALL_BOOKINGS, BOOKINGS_TABS.UPCOMING),
            [BOOKINGS_TABS.PAST]: bookingListReducerFor(BOOKINGS_VIEWS.ALL_BOOKINGS, BOOKINGS_TABS.PAST),
        }),
    }),
    filters: FiltersReducer,
});

export const initialState = {
    common: {...commonInitialState},
    local: {...localInitialState},
    bookingForm: {...bookingFormInitialState},
    bookingList: {
        [BOOKINGS_VIEWS.MY_BOOKINGS]: {
            [BOOKINGS_TABS.UPCOMING]: {...bookingListInitialState},
            [BOOKINGS_TABS.PAST]: {...bookingListInitialState},
        },
        [BOOKINGS_VIEWS.ALL_BOOKINGS]: {
            [BOOKINGS_TABS.UPCOMING]: {...bookingListInitialState},
            [BOOKINGS_TABS.PAST]: {...bookingListInitialState},
        },
    },
    filters: {...filtersInitialState},
}
